import styled from "styled-components";
import { Space, Typography } from "antd";

export const Panel = styled.div`
  max-width: min-content;
  @media (max-width: 500px) {
    max-width: 100%;
    margin-right: 10px;
  }
`;

export const ReviewContainer = styled.div`
  padding-top: 24px;
  text-align: left;
`;

export const ReviewTitleText = styled.p`
  color: #fdd440;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 10px;
`;

export const SchoolContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-row-gap: 10px;
  grid-gap: 10px;
`;

export const AccreditedContainer = styled(Space)`
  display: flex;
  font-size: 16px;
  margin-top: 10px;
`;

export const CountryName = styled(Typography.Text)`
  color: #fff;
  display: flex;
  font-weight: bold;
`;

export const Link = styled.a`
  color: #fff;
  text-decoration: underline;
  &:hover {
    color: #fff;
    opacity: 0.6;
    text-decoration: underline;
  }
`;

export const ContactText = styled(Typography.Text)`
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin-right: 5px;
`;

export const ContactEmail = styled(Link)`
  font-size: 16px;
  font-weight: bold;
`;

export const SocialImage = styled.img`
  @media (max-width: 580px) {
    width: 120px;
  }
  @media (max-width: 420px) {
    width: 100px;
  }
`;
